import CountryDataRaw from './country-data.js';

type CountryDataType = {
    name: string;
    iso2: string;
    dialCode: number;
};

let CountryData: CountryDataType[] = [];
for (let i = 0; i < CountryDataRaw.length; i++) {
    CountryData.push({
        // @ts-ignore
        name: CountryDataRaw[i]['name'],
        // @ts-ignore
        iso2: CountryDataRaw[i]['iso2'],
        // @ts-ignore
        dialCode: CountryDataRaw[i]['dialCode'],
    });
}

export default CountryData;
